module.exports = __webpack_public_path__ + "img/Rogue-human-m-70.381d285c.gif";